$(document).ready(function(){
  $('.custom-image-text').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    margin: 30,
    slidesToShow: 2,
    slidesToScroll: 2,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.8652L1 7.86523L8 0.865234" stroke="#262626"/><path d="M1 7.86523L31 7.86523" stroke="#262626"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 0.865234L30 7.86523L23 14.8652" stroke="#262626"/><path d="M30 7.86524L0 7.86523" stroke="#262626"/></svg></button>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


 $('.custom-images--slide').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    margin: 30,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.8652L1 7.86523L8 0.865234" stroke="#262626"/><path d="M1 7.86523L31 7.86523" stroke="#262626"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 0.865234L30 7.86523L23 14.8652" stroke="#262626"/><path d="M30 7.86524L0 7.86523" stroke="#262626"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });



  $('.itgv--testimonial_slide').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    margin: 30,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '175px',
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.8652L1 7.86523L8 0.865234" stroke="#262626"/><path d="M1 7.86523L31 7.86523" stroke="#262626"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 0.865234L30 7.86523L23 14.8652" stroke="#262626"/><path d="M30 7.86524L0 7.86523" stroke="#262626"/></svg></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        }
      }
    ]
  });



  $('.itgv--sliding_main').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    margin: 30,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.8652L1 7.86523L8 0.865234" stroke="#262626"/><path d="M1 7.86523L31 7.86523" stroke="#262626"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 0.865234L30 7.86523L23 14.8652" stroke="#262626"/><path d="M30 7.86524L0 7.86523" stroke="#262626"/></svg></button>',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  $('.itgv--img-with-text__slider').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 300,
    margin: 30,
    slidesToShow: 1,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.8652L1 7.86523L8 0.865234" stroke="#262626"/><path d="M1 7.86523L31 7.86523" stroke="#262626"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 0.865234L30 7.86523L23 14.8652" stroke="#262626"/><path d="M30 7.86524L0 7.86523" stroke="#262626"/></svg></button>'
  });


    $('.itgv--team__slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    margin: 30,
    slidesToShow: 5,
    slidesToScroll: 5,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.8652L1 7.86523L8 0.865234" stroke="#262626"/><path d="M1 7.86523L31 7.86523" stroke="#262626"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 0.865234L30 7.86523L23 14.8652" stroke="#262626"/><path d="M30 7.86524L0 7.86523" stroke="#262626"/></svg></button>',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

   $(document).on("click",".DstSelectBtn",function() {
      // alert('');
      //$(this).parent().find('.DstHidden').trigger('click');

        var basicprice = +$('.DstPriceChange').attr('data-attr');
        console.log(basicprice);
        var price = +$(this).find(".AddonProduct").attr('data-price');        
     // console.log(price);
     
      if ($(this).find('input').prop('checked') == true) {
            $(this).find('input').prop("checked", false);
            $(this).find('span').text('Select');

          // var total = basicprice + price; 
          // var totalminus = total - price;
          //  console.log(totalminus);
          // var productPriceX=100; 
          // var quotient = Math.floor(totalminus/productPriceX); 
          // var convertedPrice=quotient.toFixed(2); 
        
          //  console.log(convertedPrice);
          //   $('.DstPriceChange').html(convertedPrice);
        } else {
            $(this).find('input').prop("checked", true);
            $(this).find('span').text('Selected');
          //   var total = basicprice + price; 

          // var productPriceX=100; 
          // var quotient = Math.floor(total/productPriceX); 
          // var convertedPrice=quotient.toFixed(2); 
        
          //  console.log(convertedPrice);
          //   $('.DstPriceChange').text("$" + convertedPrice);
      }
     BundlePriceFunction();
     });



    function BundlePriceFunction() {
        var counter = 0.00;
        if ($('.cust-meta_product input.AddonProduct[type="checkbox"]:checked').length) {
            $('.cust-meta_product input.AddonProduct[type="checkbox"]:checked').each(function(index) {
              var GetSelectedPrice = Number($(this).attr('data-price')); 
                console.log("GetSelectedPrice + " + GetSelectedPrice);
                counter+=GetSelectedPrice;
            });
        }
          console.log("counter + " + counter);
          var OriginalPrice = Number($('.DstPriceChange').attr('data-attr'));
          var TotalPrice = OriginalPrice + counter;


          TotalPrice = TotalPrice / 100;
          TotalPrice = TotalPrice.toFixed(2)
          //var productPriceX = 100; 
          //var quotient = Math.floor(TotalPrice/productPriceX); 
          //var convertedPrice = quotient.toFixed(2); 
          $('.DstPriceChange').text("$" + TotalPrice);
      }


});
